import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { draftToMarkdown, markdownToDraft } from 'markdown-draft-js';
import { EditorContext } from '../../../hoc/Editor';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import styles from './styles.less';

const Editor = dynamic(() => import('react-draft-wysiwyg').then(m => m.Editor), { ssr: false });

const toolbar = {
  options: ['inline', 'blockType', 'list', 'history'],
  inline: {
    options: ['bold', 'italic'],
  },
  blockType: {
    options: ['Normal', 'H3', 'H4', 'H5', 'H6'],
  },
  list: {
    options: ['unordered', 'ordered'],
  },
};

const Wysiwyg = ({ defaultValue, onChange, placeholder }) => {
  const [editorState, setEditorState] = React.useState(null);
  const [load, setLoad] = React.useState(null);
  const { locale } = React.useContext(EditorContext);

  React.useEffect(() => {
    if (defaultValue) {
      const rawData = markdownToDraft(defaultValue);
      const contentState = convertFromRaw(rawData);
      const newEditorState = EditorState.createWithContent(contentState);
      setEditorState(newEditorState);
    }
  }, [locale]);

  React.useEffect(() => {
    setLoad(true);
  }, []);

  const onEditorStateChange = state => {
    setEditorState(state);

    const rawContent = convertToRaw(state.getCurrentContent());
    const markdown = draftToMarkdown(rawContent);

    onChange(markdown);
  };

  return (
    <div>
      {load && (
        <Editor
          editorClassName={styles.wys}
          editorState={editorState}
          onEditorStateChange={onEditorStateChange}
          toolbar={toolbar}
          placeholder={placeholder}
        />
      )}
    </div>
  );
};

Wysiwyg.propTypes = {
  onChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
};

Wysiwyg.defaultProps = {
  placeholder: '',
  defaultValue: '',
};

export default Wysiwyg;
